import assoc from "ramda/es/assoc"
import compose from "ramda/es/compose"
import {
  INITIAL,
  PENDING,
  COMPLETED,
  FAILED,
} from "src/engine/modules/constants"
import {
  LOAD_PERMISSIONS_STARTED,
  LOAD_PERMISSIONS_COMPLETED,
  LOAD_PERMISSIONS_FAILED,
} from "../actions/types"

const INITIAL_STATE = {
  status: INITIAL,
  allPermissions: [],
  role: null,
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOAD_PERMISSIONS_STARTED: {
      return compose(
        assoc(`status`, PENDING),
        assoc(`role`, action.payload.role),
      )(state)
    }
    case LOAD_PERMISSIONS_COMPLETED: {
      return compose(
        assoc(`status`, COMPLETED),
        assoc(`allPermissions`, action.payload.allPermissions),
      )(state)
    }
    case LOAD_PERMISSIONS_FAILED: {
      return assoc(`status`, FAILED)(state)
    }
    default:
      return state
  }
}
